import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** Seznam popisek / hodnota (detail dokladu v panelu). */
export const KeyValueList = ({ items, className }: { items: { label: ReactNode; value: ReactNode }[]; className?: string }) => (
  <dl className={cn('divide-y border-y', className)}>
    {items.map((item, i) => (
      <div key={i} className="flex items-baseline justify-between gap-4 py-2.5 text-sm">
        <dt className="text-muted-foreground">{item.label}</dt>
        <dd className="min-w-0 truncate text-right tabular">{item.value}</dd>
      </div>
    ))}
  </dl>
)
